export default "__VITE_ASSET__CaATmDF7__"